import React from 'react';
import { useTranslation } from 'react-i18next';
import { get, set, sequence } from '@totalsoft/change-tracking-react';
import { Checkbox, FormControlLabel, Grid, FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import Typography from '@mui/material/Typography';
import { TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { useInsuranceTypeConfiguration } from 'hooks';
import { insuranceTypeNames } from 'constants/defaultValues';
import { emptyString } from 'constants/defaultValues';

const InsurersComponent = ({ insurersLens, validationInsurers, insuranceTypeCode, readOnly }) => {
  const { t } = useTranslation();

  const { rcaInsuranceTypeConfiguration } = useInsuranceTypeConfiguration(new Array(insuranceTypeNames.RCA));

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography fontWeight='bold'>{t('Offer.Edit.InsuranceData.Insurer')}</Typography>
      </Grid>
      {(insurersLens |> sequence).map((insurer, index) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  id={'InsuranceData_Insurer_' + index}
                  checked={Boolean(insurer.selected |> get)}
                  disabled={readOnly}
                  onChange={insurer.selected |> set |> onCheckBoxChange}
                />
              }
              label={insurer.name |> get}
            />
            {(insurer.selected |> get) && insuranceTypeCode === rcaInsuranceTypeConfiguration?.PropertyCode ? (
              <Grid item xs={10} md={8}>
                <TextField
                  id='InsuranceData_Commission'
                  isNumeric
                  fullWidth
                  inputProps={{ decimalScale: 2 }}
                  disabled={readOnly}
                  label={t('Offer.Edit.InsuranceData.Commission')}
                  value={insurer.requestedCommissionPercent |> get || emptyString}
                  onChange={insurer.requestedCommissionPercent |> set}
                  error={!isValid(validationInsurers[index].requestedCommissionPercent)}
                  helperText={getErrors(validationInsurers[index].requestedCommissionPercent)}
                />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        );
      })}
      <Grid item xs={12}>
        <FormHelperText error={!isValid(validationInsurers)}>{getErrors(validationInsurers)}</FormHelperText>
      </Grid>
    </Grid>
  );
};
InsurersComponent.propTypes = {
  insurersLens: PropTypes.object.isRequired,
  validationInsurers: PropTypes.object,
  insuranceTypeCode: PropTypes.string,
  readOnly: PropTypes.bool.isRequired
};
export default InsurersComponent;
